import { render } from "./FilterAtasan.vue?vue&type=template&id=5b52f5a8"
import script from "./FilterAtasan.vue?vue&type=script&lang=js"
export * from "./FilterAtasan.vue?vue&type=script&lang=js"
script.render = render

export default script